import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=24567798&scoped=true&"
import script from "./login2.vue?vue&type=script&lang=ts&"
export * from "./login2.vue?vue&type=script&lang=ts&"
import style0 from "./login2.vue?vue&type=style&index=0&id=24567798&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24567798",
  null
  
)

export default component.exports